module.exports = __webpack_public_path__ + "static/media/search_logo_green.dff4599c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/images/search_logo_green.png
// module id = 2081
// module chunks = 0